import PropTypes from 'prop-types';
import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { Small } from 'foundations-components/transitional/components/Small';
import { BOT, CONVERSATIONS, FORM } from 'customer-data-objects/property/PropertySourceTypes';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getMessage = source => {
  switch (source) {
    case BOT:
      return `cardProperties.recentPropertyChangeWarning.BOT`;
    case CONVERSATIONS:
      return `cardProperties.recentPropertyChangeWarning.CONVERSATIONS`;
    case FORM:
      return `cardProperties.recentPropertyChangeWarning.FORM`;
    default:
      return `cardProperties.recentPropertyChangeWarning.default`;
  }
};
const RecentPropertyChangeWarning = ({
  value,
  source
}) => {
  const message = getMessage(source);
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "-200",
    children: /*#__PURE__*/_jsxs(Small, {
      use: "help",
      children: [/*#__PURE__*/_jsx(StatusDot, {
        use: "warning"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: message,
        options: {
          value
        }
      })]
    })
  });
};
RecentPropertyChangeWarning.propTypes = {
  value: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(RecentPropertyChangeWarning);